export const costIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><path fill="none" stroke="currentColor" stroke-width="1.6" d="M1 12.25C1 18.463 6.037 23.5 12.25 23.5S23.5 18.463 23.5 12.25 18.463 1 12.25 1 1 6.037 1 12.25zm9 2.25a2.25 2.25 0 1 0 2.25-2.25A2.25 2.25 0 1 1 14.5 10m-2.25-3.75v1.5m0 9v1.5"/></svg>`,
    name: 'cost' as const
};